import React, { useState } from "react";

import {
  IonCard,
  IonCardContent,
  IonButton,
  IonItem,
  IonLabel,
  IonTextarea,
  IonText
} from "@ionic/react";

import { useParams, useHistory } from "react-router-dom";

import { createUseStyles } from "react-jss";

import Page from "../../components/Page/Page";

import { ButtonLoading } from "../../components/Ui/ButtonLoading"

import { HelpNewState, HelpNewInitial } from "../../interfaces/help";
import { useChange } from "../../hooks/useChange";
import { useHelp, useHelpCreate } from "../../hooks/useHelps";

import CheckedIcon from "../../assets/icons/checked.svg";

const useStyles = createUseStyles({
  checked: {},
  img: {
    width: "40%",
    margin: "20px auto",
    display: "block"
  },
  title: {
    textAlign: "center",
    fontSize: 20
  },
  btnBack: {
    width: "80%",
    margin: "10px auto",
    display: "block",
    marginTop: 20
  }
});

const HelpPage: React.FC = () => {
  const { ticket_id, type_id } = useParams();

  const { goBack } = useHistory();

  const [state, setState] = useState<HelpNewState>({ ...HelpNewInitial });

  const { onIonChange } = useChange({ setState });

  const { data, loading } = useHelp(type_id);

  const classes = useStyles();

  const [
    addHelp,
    { data: dataMutate, loading: loadingSend, error },
  ] = useHelpCreate();

  const onSubmit = (event: any) => {
    event.preventDefault();
    addHelp({
      variables: {
        description: state.description,
        ticket_id,
        type_id,
      },
    });
  };

  const back = ticket_id ? `/page/passage/${ticket_id}` : "/page/passages";

  return (
    <Page
      name={`Ajuda ${!loading ? " - " + data.getHelpType.title : ""}`}
      back={back}
    >
      <div className="help-page">
        {dataMutate !== undefined && !error ? (
          <div className={classes.checked}>
            <img className={classes.img} alt="Pedido de ajuda enviado!" src={CheckedIcon} />
            <IonText>
              <h3 className={classes.title}>Pedido de ajuda enviado!</h3>
            </IonText>
            <IonButton className={classes.btnBack} onClick={() => goBack()}>Ok</IonButton>
          </div>
        ) : null}
        <IonCard>
          <IonCardContent className="no-padding">
            {dataMutate === undefined ? (
              <form onSubmit={onSubmit}>
                <IonItem>
                  <IonLabel>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: !loading ? data.getHelpType.description : null,
                      }}
                    ></div>
                  </IonLabel>
                </IonItem>
                <IonItem>
                  <IonLabel position="floating">Descrição</IonLabel>
                  <IonTextarea
                    autofocus
                    rows={9}
                    cols={20}
                    name="description"
                    onIonChange={onIonChange}
                    placeholder="Conte um pouco do acontecido"
                  />
                </IonItem>
                <div style={{ width: "100%", display: "flex" }}>
                  <ButtonLoading loading={loadingSend} disabled={
                      (state.description?.length !== undefined
                        ? state.description?.length === 0
                        : true) || loadingSend
                    } style={{ width: "80%", height: 35, margin: "15px auto" }} text="Enviar" textLoading="Enviando..." />
                </div>
              </form>
            ) : null}
          </IonCardContent>
        </IonCard>
      </div>
    </Page>
  );
};

export default HelpPage;
